import { render, staticRenderFns } from "./examQuestionListAuto.vue?vue&type=template&id=56ea6e3e&"
import script from "./examQuestionListAuto.vue?vue&type=script&lang=js&"
export * from "./examQuestionListAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports